import React from 'react';
import Head from 'next/head';

import SeoSearchBoxScript from '../components/SeoSearchBox';
import Seo from '../components/Seo';
import HomeHero from '../components/HomeHero';
import ProductComparison from '../components/ProductComparison';
import FlyerCategoryTiles from '../components/FlyerCategoryTiles';
import MasonryDisplay from '../components/MasonryDisplay';
import AutoSlat from '../components/AutoSlat';
import CategoryBlocks from '../components/CategoryBlocks';
import BlogPosts from '../components/BlogPosts';

import PageData from '../assets/LandingPages/Home';

import { SIZE_SM } from '../utils/screens';

import useWithinSizeList from '../hooks/useWithinSizeList';

const Home = () => {
  const {
    APP_PROMO,
    BLOG_POSTS,
    DESIGNER_COLLECTIONS,
    FLYER_CATEGORY_TILES,
    HOME_HERO,
    MASONRY_CATEGORIES,
    MOBILE_HERO_PROMO,
    PAPER_SOURCE_PROMO,
    PARTYSHOP_BANNER,
    PRODUCT_COMPARISON,
    UYO_SLAT,
    seo,
  } = PageData;

  const isSmallBrowser = useWithinSizeList([SIZE_SM]);

  return (
    <>
      <Head>
        <meta content="dj2880i9z1ft0orfbyygj6ckrifoqc" name="facebook-domain-verification" />
      </Head>
      <Seo {...seo} />
      <SeoSearchBoxScript />
      <div className={`max-w-screen-2xl mx-auto overflow-hidden relative text-lapel`}>
        <HomeHero {...HOME_HERO} />
        {isSmallBrowser && <FlyerCategoryTiles tiles={FLYER_CATEGORY_TILES} />}
        {isSmallBrowser && <AutoSlat {...APP_PROMO} />}
        {isSmallBrowser && <AutoSlat {...MOBILE_HERO_PROMO} />}
        <ProductComparison {...PRODUCT_COMPARISON} />
        <CategoryBlocks {...DESIGNER_COLLECTIONS} />
        <AutoSlat {...UYO_SLAT} />
        <MasonryDisplay sections={MASONRY_CATEGORIES} />
        <AutoSlat {...PARTYSHOP_BANNER} />
        <AutoSlat {...PAPER_SOURCE_PROMO} />
        <BlogPosts {...BLOG_POSTS} />
      </div>
    </>
  );
};

export default React.memo(Home);
